import client from './client';

export const runCode = async ({ sourceCode, languageId, input = '', expectedOutput = '' }) => {
  const response = await client.post('/coding/run', {
    sourceCode,
    languageId,
    input,
    expectedOutput,
  });
  return response.data;
};

export const evaluateCode = async ({ questionId, sourceCode, languageId }) => {
  const response = await client.post('/coding/evaluate', {
    questionId,
    sourceCode,
    languageId,
  });
  return response.data;
};
